<template>
	<div class="col-span-2">
		<div id="chatWhatsapp">
			<div class="chatWhatsAppBody">
				<vx-card class="no-scroll-content" id="containerChatBody">
					<div
						v-for="lst in listMessChat.data"
						class="messageWhatsApp"
						:class="{'messageWhatsApp_right': iIncomingMessage(lst.status)}"
					>
						<div class="top">
							<div class="author">
								<div class="avatar">
									<img
										v-if="listMessChat['info'].user.avatarUri && iIncomingMessage(lst.status)"
										:src="filePath(listMessChat['info'].user.avatarUri)"
										alt=""
										width="40" height="40"
									>
									<feather-icon v-else icon="UserIcon" class="client-avatar" />	
								</div>
								<div v-if="iIncomingMessage(lst.status)" class="name">
									{{ listMessChat['info'].user.userPhone }}&nbsp;
									<span v-if="listMessChat['info'].user.userPhone != listMessChat['info'].user.userName && listMessChat['info'].user.userName != ''">
										({{ listMessChat['info'].user.userName }}) 
									</span>
								</div>
								<div v-else class="name">
									CRM
								</div>
							</div>

							<div>
								<vs-button class="frsButtonWhatsApp small" color="success" 
									@click="replyToMess(lst)">
										{{ $t('replyTo') }}
								</vs-button>
							</div>

							<div>
								<div class="time">
									{{ lst.created | moment('DD.MM.YYYY HH:mm:ss A') }}
								</div>
								<div class="w-full text-right">
									<img
										:src="showStatusMess(lst.status)"
										width="20" height="20"
										style="float: right;"
									>
								</div>
							</div>

						</div>
						<div v-if="lst.quotedMessage != '' && lst.quotedMessage != null" v-html="lst.quotedMessage"></div>
						<div v-if="lst.type == 'text'" v-html="lst.message"></div>
						<div v-if="lst.type == 'missing_call'">{{ $t('whatsappChatMissingCall') }}</div>
						<div v-if="lst.type == 'image'">
							<img
								:src="lst.contentUri"
								class="w-full"
							>
							<div v-if="lst.message != null && lst.message != ''" v-html="lst.message"></div>
						</div>
						<div v-if="lst.type == 'document'">
							<a :href="lst.contentUri" target="_blank">{{ lst.contentUri }}</a>
							<div v-if="lst.message != null && lst.message != ''" v-html="lst.message"></div>
						</div>
						<div v-if="lst.type == 'audio'">
							<!-- <audio controls autoplay muted> -->
							<audio controls>
								<source :src="lst.contentUri" type="audio/ogg">
								<source :src="lst.contentUri" type="audio/mpeg">
								Your browser does not support the audio element.
							</audio>
							<div v-if="lst.message != null && lst.message != ''" v-html="lst.message"></div>
						</div>
						<div v-if="lst.type == 'video'">
							<video class="w-6/12" controls>
								<source :src="lst.contentUri" type="video/mp4">
								<source :src="lst.contentUri" type="video/ogg">
								Your browser does not support the video tag.
							</video>
							<div v-if="lst.message != null && lst.message != ''" v-html="lst.message"></div>
						</div>
					</div>
					<div id="end-of-messages"></div>
				</vx-card>
			</div>

			<div class="txt_plagin_msg_whatsapp">
				<vue-editor
					v-model="msg" 
					:editor-toolbar="customToolbar" 
					rows="3"
					class="vue_editor_height_whatsapp"
				/>
			</div>

			<div class="send">
				<vx-input-group>
					<div class="vs-component vs-con-input-label vs-input vs-input-primary">
						<div class="vs-con-input">
						</div>
					</div>
					<div class="frsGroupButtonWhatsApp">

						<vs-button class="frsButtonWhatsApp" color="success" 
							@click="addMarkAsRead">
								{{ $t('txtBtnChatMarkAsRead') }}
						</vs-button>
						<vs-button class="frsButtonWhatsApp" color="primary" 
							@click="addMessage" type="filled">
								{{ $t('send') }}
						</vs-button>
						<label class="file-input">
							<div class="file-input__container">
								<feather-icon class="file-input__img" icon="PaperclipIcon" />
							</div>
							<input ref="fileInput" type="file" class="hidden" @input="uploadFile">
						</label>

					</div>
				</vx-input-group>
			</div>
		</div>
	</div>
</template>

<script>
import VxCard from '@/components/vx-card/VxCard'
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import { VueEditor, Quill }from "vue2-editor";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
// import vSelect from "vue-select";
import moment from 'moment';

// import { wait } from 'ckeditor5';

// Generate code-friendly font names
function getFontName(font) {
    return font.toLowerCase().replace(/\s/g, "-");
}

// Specify Quill fonts
const fontList = ['Arial', 'Courier', 'Garamond', 'Tahoma', 'Times New Roman', 'Verdana'];
const fontNames = fontList.map(font => getFontName(font));
const fonts = Quill.import('formats/font');
fonts.whitelist = fontNames;
Quill.register(fonts, true);

// Add fonts to CSS style
let fontStyles = "";
fontList.forEach(function(font) {
    let fontName = getFontName(font);
    fontStyles += ".ql-snow .ql-picker.ql-font .ql-picker-label[data-value=" + fontName + "]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=" + fontName + "]::before {" +
        "content: '" + font + "';" +
        "font-family: '" + font + "', sans-serif;" +
        "}" +
        ".ql-font-" + fontName + "{" +
        " font-family: '" + font + "', sans-serif;" +
        "}";
});

const node = document.createElement('style');
node.innerHTML = fontStyles;
document.body.appendChild(node);

export default {
	mixins: [databaseManager, notifier],
	name: 'ListChatsWazzupSection',
	components: {
        VxCard,
		VueEditor,
		VuePerfectScrollbar,
		// vSelect,
		// ModalAddNewManagerChatWhatsApp,
	},
	props: {
		// idChat: { required: true },
    },
	data () {
		return {
			// selectedManagerForOrder: null,
			// addNewManagerActive: false,
			// managerGetOrderActive: false,
			// modalAddNewManagerActive: false,
			// listManager: [],

			chat: null,
			replyToId: null,
			manager: null,
			container: null,
			idChat: null,
			listMessChat: [],
			msg: '',
			customToolbar: [
				// [{ font: fonts.whitelist }],
				// [{ header: [false, 1, 2, 3, 4, 5, 6] }],
				// [{ size: ["small", false, "large", "huge"] }],
				["bold", "italic", "underline", "strike"],
				// [
				// 	{ align: "" },
				// 	{ align: "center" },
				// 	{ align: "right" },
				// 	{ align: "justify" }
				// ],
				// [{ header: 1 }, { header: 2 }],
				// ["blockquote", "code-block"],
				[{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
				// [{ script: "sub" }, { script: "super" }],
				[{ indent: "-1" }, { indent: "+1" }],
				// [{ color: [] }, { background: [] }],
				["link", "image", "video"],
				// ["link", "image", "video", "formula"],
				// [{ direction: "rtl" }],
				["clean"]
			],
		}
	},
	computed: {
		compColorSpanManager() {
			let cl = 'frsSelectSpanColorManager';
			if(this.manager !== null && this.manager.id !== undefined) {
				return cl + ' frsColorGreenSpan';
			} else {
				return cl + ' frsColorRedSpan';
			}
		},
	},
	methods: {
		async uploadFile() {
			try {
				const [file] = this.$refs.fileInput.files;
				// const idChat = this.$store.state.chat.idChat;
				const [uploadedFile] = await this.dbUploadMany([file]);
				const messageText = `${uploadedFile.fullUrl}`;

				if(messageText != '' && messageText != null && messageText != undefined) {
					await this.dbSendFileWhatsapp(this.idChat, messageText, this.replyToId);
					await this.openNewChat(this.chat);
				}
			} catch (e) {
				console.error(e);
			}
		},
		replyToMess(itemMes) {
			let stringWithoutTags = itemMes.message.replace(/(<([^>]+)>)/gi, '');
			stringWithoutTags = stringWithoutTags.replace(/\n/g, ' ');
			let sliced = stringWithoutTags.slice(0,25);
			if (sliced.length < stringWithoutTags.length) {
				sliced += '...';
			}

			let d = moment(itemMes.created).format('DD.MM.YYYY HH:mm:ss');

			this.msg = '<p data-reprlyto class="p_reply_to">'
				+ this.$t('txtInChatReplyTo')
				+ ': (<strong>' 
				+ sliced 
				+ '</strong>) ' 
				+ d
				+ '</p><br>';

			this.replyToId = itemMes.id;
		},
		// async getListManager(manager) {
		// 	this.listManager = await this.dbGetListMangers();

		// 	if(manager !== null && manager.id !== undefined) {
		// 		let manID = manager;
		// 		let manFind = null;

		// 		this.listManager.forEach(function(elem) {
		// 			if(elem.id == manID.id) {
		// 				manFind = elem;
		// 				return;
		// 			}
		// 		});
		// 		this.selectedManagerForOrder = manFind;
		// 	} else {
		// 		this.selectedManagerForOrder = this.$t('noManagerWhatsAppChat');
		// 	}
		// },
		// onChangeSelectedManagerForOrder() {
		// 	this.addNewManagerActive = true;
		// },
		async addMarkAsRead() {
            try {
				const rezMark = await this.dbChatWhatsAppMarkAsRead(this.idChat);
				if(rezMark) {
					// this.isChatUnread = false;
					this.notifySuccess(`${this.$t('notifySuccessChatMarkAsRead')}`);
				}
            } catch(e) {
                this.notifyError(e.message);
            }
		},
		showStatusMess(status) {
			if(status =='read') {
				return require('@/assets/images/whatsapp/read_w.png');
				// return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" style="font-size: 20px; height: 20px; width: 20px; color: rgb(0, 172, 193) !important; caret-color: rgb(0, 172, 193) !important;"><path d="M0.41,13.41L6,19L7.41,17.58L1.83,12M22.24,5.58L11.66,16.17L7.5,12L6.07,13.41L11.66,19L23.66,7M18,7L16.59,5.58L10.24,11.93L11.66,13.34L18,7Z"></path></svg>';
			}
			if(status =='delivered') {
				return require('@/assets/images/whatsapp/delivered_w.png');
				// return '<span data-v-eed3e000="" aria-hidden="true" class="v-icon notranslate theme--light" style="font-size: 20px; height: 20px; width: 20px; color: rgb(158, 158, 158); caret-color: rgb(158, 158, 158);"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg" style="font-size: 20px; height: 20px; width: 20px;"><path d="M0.41,13.41L6,19L7.41,17.58L1.83,12M22.24,5.58L11.66,16.17L7.5,12L6.07,13.41L11.66,19L23.66,7M18,7L16.59,5.58L10.24,11.93L11.66,13.34L18,7Z"></path></svg></span>';
			}
			if(status =='sent') {
				return require('@/assets/images/whatsapp/sent_w.png');
			}
			if(status =='inbound') {
				return require('@/assets/images/whatsapp/inbound_w.png');
			}
			if(status =='error') {
				return require('@/assets/images/whatsapp/error_w.png');
			}
		},
		filePath(file) {
			if (!file) {
				return;
			}

			const fileName = file.toLowerCase();
			return fileName;
		},
		async openNewChat(chat) {
			const role = this.$store.state.auth.role;

			// if(role === 'admin') await this.getListManager(chat.manager);

			this.scrollToBottom();

			// this.manager = chat.manager;
			this.chat = chat;

			// this.idChat = chat.id;
			this.listMessChat = await this.dbviewOneChatWhatsapp(this.idChat);

			this.msg = '';
			this.replyToId = null;

			this.scrollToBottom();
		},
		scrollToBottom() {
			const endOfMessages = document.getElementById("end-of-messages");
			setTimeout(() => endOfMessages.scrollIntoView(false), 500);
		},
		iIncomingMessage(status) {
			if(status == 'inbound') {
				return true;
			}
			return false;
		},
		async uploadMessage(message, replyToId = null, encode = true) {
			try {
				if(message != '') {
					// const msg = encode ? encodeURI(message) : message;
					const msg = message;

					// const asAuthor = this.asAuthor;
					// await this.$store.dispatch('sendMessage', { msg, asAuthor });			
					await this.dbSendMessageWhatsapp(this.idChat, msg, replyToId);

					await this.openNewChat(this.chat);
					// const atBottom = this.checkIfAtTheBottom();
					// await this.updateMessage(true, atBottom);
					// setTimeout(() => this.loadMessages(), 100);
				}
			} catch (error) {
				console.error(error)
			}
		},
		addMessage() {
			this.uploadMessage(this.msg, this.replyToId)
			this.msg = '';
			this.replyToId = null;
		},
	},
	async mounted() {
		this.idChat = this.$route.params.id;

		this.listMessChat = await this.dbviewOneChatWhatsapp(this.idChat);

		const role = this.$store.state.auth.role;

		// if(role === 'admin') await this.getListManager();

	},
	created() {
		setTimeout(() => this.scrollToBottom(), 1500);
	}
}
</script>

<style lang="scss">
	@import "../../assets/scss/vuexy/functions";
	@import "../../assets/scss/vuexy/variables";

	.file-input {
		border-radius: 100%;
		margin-left: 10px;
		flex: 37px 0 0;
		width: 37px;
		height: 37px;
		overflow: inherit;
		padding: 0;
		cursor: pointer;
		background-color: $primary;

		&__container {
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 100%;
			padding: 0;
			width: 100%;
			height: 100%;
		}

		&__img {
			width: 22px;
			height: 22px;
			color: white;
		}
	}

	.p_reply_to {
		background-color:lightgreen;
	}
	.cursorPoint {
		cursor: pointer;
	}

	.frsSelect {
		min-width: 300px;
		font-size: small;
		line-height: 20px;
		margin: auto;
	}
	.frsSelectSpanManager {
		display: flex;
		line-height: 20px;
		font-size: small;
		color: black;
	
		img {
			width: 30px;
			height: 30px;
			margin-right: 10px;
		}	

	}
	.frsSelectSpanColorManager {
		display: flex;
		line-height: 20px;
		font-size: small;
	}

	// .frsSelectSpanColorManager .feather-icon {
	// 	line-height: 20px;
	// }

	.frsColorGreenSpan {
		color: green;
	}
	.frsColorOrangeSpan {
		color: orange;
	}
	.frsColorRedSpan {
		color: red;
	}

	.frsGroupButtonWhatsApp {
		display: flex;
		float: right;
	}

	.frsGroupButtonWhatsApp > .frsButtonWhatsApp {
		margin-left: 0.25rem;
		padding: 0.75rem !important;
	}

	.txt_plagin_msg_whatsapp {
		display: flex;
		margin-bottom: 5px;
	}

	.vue_editor_height_whatsapp {
		overflow-y: scroll;
		width: 100%;
	}

	#quill-container {
		height: 80px !important;
	}

	#quill-container .ql-editor {
		min-height: 80px !important;
	}

	.vx-card {
		overflow-y: auto;
    	overflow-x: hidden;
		min-height: 100px;
	}

	.no-scroll-content {
		height: calc(var(--vh, 1vh)* 100 - 23rem) !important;
	}

    .whatsapp-section-message-wrapper {
        width: 100%;
    }

	#containerChatBody {
		background-color: #e8eaf6;
	}

	.chatWhatsAppBody {
		overflow-y: auto;
	}

	.head {
		padding-left: 20px;
		padding-bottom: 5px;
	}

	.messageWhatsApp_right {
		margin-left: 0 !important;
	}

	.messageWhatsApp {
			background-color: #fff;
			border-radius: 8px;
			padding: 9px;
			width: 89%;
			margin-left: auto;
			margin-bottom: 20px;
			box-shadow: 0px 2px 5px 0px #0000001f;

			&:last-child {
				margin-bottom: 0;
			}

			&.isManager {
				margin-left: 0;
			}

			.main {
				padding-top: 7px;
				word-break: break-word;
				hyphens: auto;
			}

			.author {
				display: flex;
				align-items: center;
				padding-bottom: 5px;

				.avatar {
					margin-right: 10px;
					width: 40px;
					height: 40px;
					overflow: hidden;
					border-radius: 100%;

					img {
						max-width: 100%;
						height: 100%;
						width: 100%;
					}
				}

				.client-avatar {
					display: flex;
					justify-content: center;
					align-items: center;
					border-radius: 100%;
					width: 100%;
					height: 100%;
					//background-color: #eaeaea;
					background-color: #42A5F5;
					color: white;

					svg {
						width: 75%;
						height: 75%;
					}
				}

				.name {
					font-size: rem(16px);
					display: flex;
					flex-direction: column;
					justify-content: center;
					line-height: 1;
				}
			}

			.top {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				border-bottom: 2px solid #d6d6d6;
			}

			.time {
				font-weight: 500;
				font-size: rem(12px);
				text-align: right;
			}

		}
</style>
